<template>
  <div class="policy-summary-card">
    <strong class="policy-summary-heading">根据文章，简要提炼核心内容</strong>
    <div class="policy-summary-title" :title="title">{{ title || '政策详情' }}</div>
    <div class="policy-summary-preview" :title="preview">{{ previewText }}</div>
  </div>
</template>

<script>
export default {
  name: 'PolicySummaryQuestion',
  props: {
    title: { type: String, default: '' },
    preview: { type: String, default: '' },
  },
  computed: {
    previewText() {
      return this.preview.replace(/\s+/g, ' ').trim() || '文章内容已发送';
    },
  },
};
</script>

<style scoped lang="less">
.policy-summary-card {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, .85);
  border-radius: 14px 14px 4px 14px;
  background: linear-gradient(120deg, rgba(228, 239, 255, .9), rgba(244, 232, 255, .86));
  box-shadow: 0 4px 16px rgba(91, 106, 175, .1);
  text-align: left;
}

.policy-summary-heading,
.policy-summary-title,
.policy-summary-preview {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 22px;
}

.policy-summary-heading { color: #36447b; font-size: 15px; }
.policy-summary-title { color: #465781; font-size: 13px; font-weight: 500; }
.policy-summary-preview { color: #647096; font-size: 13px; }
</style>
